<template>
  <article class="heading-component w-100">
    <div class="heading-component-inner">
      <h1 v-if="level === 1" class="heading-component-title" :class="variant">{{ title }}</h1>
      <h2 v-if="level === 2" class="heading-component-title" :class="variant">{{ title }}</h2>
      <h3 v-if="level === 3" class="heading-component-title" :class="variant">{{ title }}</h3>
      <h4 v-if="level === 4" class="heading-component-title" :class="variant">{{ title }}</h4>
      <h5 v-if="level === 5" class="heading-component-title" :class="variant">{{ title }}</h5>
      <h6 v-if="level === 6" class="heading-component-title" :class="variant">{{ title }}</h6>
      <div>
        <slot></slot>
      </div>
    </div>
  </article>
</template>

<script>
import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";

export default Vue.extend({
  name: "AppHeading",
  props: {
    title: String,
    level: {
      required: false,
      default: 2,
      type: Number
    },
    variant: String
  }
});
</script>

<style lang="scss" scoped>
h2,
.h2 {
  font-size: 18px;
}

h3,
.h3 {
  font-size: 17px;
}

h4,
h5,
h6,
.h4,
.h5,
.h6 {
  font-size: 16px;
}
</style>
